/**
 * Kimlik numarası doğrulamaları (yalnız biçim + sağlama hanesi; kişiyi doğrulamaz).
 */

/** TC kimlik no: 11 hane, ilk hane 0 değil; 10. hane = ((tek haneler×7) − çift haneler) mod 10; 11. hane = ilk 10 hanenin toplamı mod 10. */
export const isValidTckn = (value: string): boolean => {
  const s = (value || "").trim();
  if (!/^[1-9]\d{10}$/.test(s)) return false;
  const d = s.split("").map(Number);
  const odd = d[0] + d[2] + d[4] + d[6] + d[8];
  const even = d[1] + d[3] + d[5] + d[7];
  const d10 = ((odd * 7 - even) % 10 + 10) % 10;
  const d11 = (d.slice(0, 10).reduce((a, b) => a + b, 0)) % 10;
  return d[9] === d10 && d[10] === d11;
};

/** Vergi kimlik no: 10 hane, GİB sağlama algoritması. */
export const isValidVkn = (value: string): boolean => {
  const s = (value || "").trim();
  if (!/^\d{10}$/.test(s)) return false;
  const d = s.split("").map(Number);
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const t = (d[i] + (9 - i)) % 10;
    const p = (t * Math.pow(2, 9 - i)) % 9;
    sum += t !== 0 && p === 0 ? 9 : p;
  }
  return (10 - (sum % 10)) % 10 === d[9];
};

/**
 * TC kimlik alanı için anlık geri bildirim.
 * Boş → null (sorun yok); eksik hane → "incomplete"; 11 hane ama sağlama tutmuyor → "invalid"; doğru → "ok".
 */
export const tcknState = (value: string): null | "incomplete" | "invalid" | "ok" => {
  const s = (value || "").replace(/\D/g, "");
  if (!s) return null;
  if (s.length < 11) return "incomplete";
  return isValidTckn(s) ? "ok" : "invalid";
};

/** VKN (10) ya da TCKN (11) kabul eden karma alan. */
export const taxIdState = (value: string): null | "incomplete" | "invalid" | "ok" => {
  const s = (value || "").replace(/\D/g, "");
  if (!s) return null;
  if (s.length === 10) return isValidVkn(s) ? "ok" : "invalid";
  if (s.length === 11) return isValidTckn(s) ? "ok" : "invalid";
  return s.length < 10 ? "incomplete" : "invalid";
};
